import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";
import { mutations, queries } from "@/apollo";
import { clone } from "lodash";
import { errorMutationNotification } from "@/utils";
import { onMounted, ref, watch } from "vue";
import { apolloClient } from "@/apollo";
import { addSuccessToast } from "@/vue-service";
import { useTranslation } from "@/store/translation";



export default /*#__PURE__*/_defineComponent({
  __name: 'NicknameFormModal',
  props: {
    user: null,
    value: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { user: User, value: boolean };


const form = ref(getDefaultForm());
const { $t } = useTranslation();

const loading = ref(false)




onMounted(() => {
  resetForm()
})

function toggleModal(val: boolean) {
  emit("input", val);
}

function getDefaultForm() {
  return clone({
    nickname: props.user.nickname
  });
}

function resetForm() {
  form.value = getDefaultForm();
}

watch(() => (props.user), () => {
  resetForm();
})

async function handleSubmit() {
  try {
    loading.value = true;
    const result = await apolloClient.mutate({
      mutation: mutations.updateNickname,
      variables: {
        nickname: form.value.nickname
      }, refetchQueries: [
        {
          query: queries.user,
          variables: {
            userId: props.user.userId
          }
        },
        {
          query: queries.me,
        }
      ]
    });
    addSuccessToast('Nickname updated')
    toggleModal(false);
  } catch (err) {
    errorMutationNotification(err);
  }
  loading.value = false;
}

return { __sfc: true,form, $t, loading, props, emit, toggleModal, getDefaultForm, resetForm, handleSubmit }
}

})